<div class="spinner"></div>
<div class="spinner-status">{{ text | translate }} </div>